import api from "../../client";
export interface DeleteFileResponse {}

export const deleteFile = async (
  profileId: string,
): Promise<DeleteFileResponse> => {
  const { data } = await api.delete<DeleteFileResponse>(
    `/profile/${profileId}/delete-image`,
  );
  return data;
};
